import { authState } from "@/app/state/authState";
import type { User } from "@/app/state/useAuthStateLoader";
import { Crm } from "@/generated/graphql";
import { state } from ".";

export enum Feature {
  AiUpdateOutreach = "ai_update_outreach_v1",
  BbCrmInteractionCoding = "bb_crm_interaction_coding",
  CheckEmailV1 = "check_email_v1",
  DisableHubspot = "disable_hubspot",
  DisableSentryReplay = "disable_sentry_replay",
  DonorsKanban = "donors_kanban",
  HtmxDonorListDetail = "htmx_donor_list_detail_v1",
  PortfolioValueReport = "portfolio_value_report",
  PrecomputeAutoRecs = "precompute_auto_recs",
  ShowMockBwfLogo = "show_mock_bwf_logo",
  ShowMockDsAiScore = "show_mock_ds_ai_score",
  ShowOutcomeField = "show_outcome_field",
  ShowSummaryField = "show_summary_field",
  Tasks = "tasks",
  TopWealthScreening = "top_wealth_screening",
  VirtuousMode = "virtuous_mode",
}

export const isFeatureEnabled = (featureName: Feature): boolean => {
  return (
    authState.auth.backend?.user?.featureFlags?.some(
      (flag) =>
        flag.identifier === featureName &&
        (flag.isProdReady ||
          (authState.auth.backend?.user?.isUserThatShowsDemos &&
            authState.auth.backend?.user?.org?.isTestOrg)),
    ) || false
  );
};

export const areDynamicListsEnabled = (): boolean => {
  const user: null | User = state.auth.backend.user;
  return (
    user?.org?.crm === Crm.Blackbaud ||
    user?.org?.crm === Crm.BbCrm ||
    user?.org?.crm === Crm.Virtuous ||
    user?.canSyncDonorLists ||
    false
  );
};

export const shouldShowHouseholdNameInDonorTables = (): boolean => {
  const user: null | User = state.auth.backend.user;
  const crm = user?.org?.crm;
  return crm === Crm.Virtuous || crm === Crm.Salesforce;
};
